import { useMemo } from 'react';
import { createMatcher } from '../routerUtils';
import { useRouterRequest } from './useRouterRequest';
/**
 * Returns a boolean that indicates whether the user is currently
 * viewing the specified pattern.
 * @param pattern
 */
export var useMatchRoute = function (patterns) {
    var matcher = useMemo(function () {
        return typeof patterns === 'string'
            ? createMatcher(patterns)
            : function (pathname) {
                var matchers = patterns.map(createMatcher);
                return matchers.some(function (matcher) { return matcher(pathname); });
            };
    }, [patterns]);
    var request = useRouterRequest();
    return useMemo(function () { return !!matcher(request.pathname); }, [matcher, request]);
};
